import Page from "webPage/Page";
import ScrollMagic from "scrollmagic";
import "scrollmagic/scrollmagic/minified/plugins/animation.gsap.min";
import {animation, Power0, TimelineMax, TweenMax} from "gsap";
import {scrollMagicActive} from "index";

let parallaxController = null;
let aboutUsTween;
let aboutUsScene;
let ourApproachTween;
let ourApproachScene;
let ourCapabilitiesTween;
let ourCapabilitiesScene;

Page.register('/about-us', () => {
    /*let markers = [];
    let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    let map = new google.maps.Map(document.getElementById('map-about'), {
        center:           {lat: 40.761821, lng: 104.721680},
        zoom:             3,
        scrollwheel:      false, //removes scroll wheel functionality
        disableDefaultUI: true, //removes zoom control & street view
        mapTypeControl:   false, //removes changing the map type (Road, Satellite etc)
        draggable:        false, //stops the map being draggable (for mobile)
        scaleControl:     false, //
        zoomControl:      false, //stops zooming functionality
        styles:           [
            {
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#6791a8"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers":     [
                    {
                        "color": "#1a3646"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "geometry.stroke",
                "stylers":     [
                    {
                        "color": "#4b6878"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#64779e"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "geometry.stroke",
                "stylers":     [
                    {
                        "color": "#4b6878"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.stroke",
                "stylers":     [
                    {
                        "color": "#334e87"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#283d6a"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#6f9ba5"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers":     [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry.fill",
                "stylers":     [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#3C7680"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#304a7d"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#98a5be"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers":     [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#2c6675"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers":     [
                    {
                        "color": "#255763"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#b0d5ce"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.stroke",
                "stylers":     [
                    {
                        "color": "#023e58"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#98a5be"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.stroke",
                "stylers":     [
                    {
                        "color": "#1d2c4d"
                    }
                ]
            },
            {
                "featureType": "transit.line",
                "elementType": "geometry.fill",
                "stylers":     [
                    {
                        "color": "#283d6a"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#3a4762"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers":     [
                    {
                        "color": "#192946"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers":     [
                    {
                        "color": "#4e6d70"
                    }
                ]
            }
        ]
    });

    const image = {
        size:       new google.maps.Size(41, 50),
        scaledSize: new google.maps.Size(41, 50),
        anchor:     new google.maps.Point(20, 50),
        url:        '/images/' + (isIE11 ? 'png' : 'svg') + '/map-marker.' + (isIE11 ? 'png' : 'svg')
    };

    markers.push(new google.maps.Marker({
        position: new google.maps.LatLng(52.286530, -1.605570),
        map:      map,
        icon:     image
    }));

    markers.push(new google.maps.Marker({
        position: new google.maps.LatLng(31.230390, 121.473702),
        map:      map,
        icon:     image
    }));*/
    parallaxController = new ScrollMagic.Controller();

    aboutUsTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-about-us', 1, {yPercent: 30, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
            TweenMax.fromTo('.js-floating-product-1', 1, {yPercent: 20, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    aboutUsScene = new ScrollMagic.Scene({
        triggerElement: '.overlap--center-about-top .overlap__image',
        duration: aboutUsGetHeight,
        triggerHook: "onEnter"
    }).setTween(aboutUsTween).addTo(parallaxController);

    ourApproachTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-our-approach', 1, {yPercent: 22, xPercent: 0}, {yPercent: -10, xPercent: 0, ease: Power0.easeNone}),
        ]);

    ourApproachScene = new ScrollMagic.Scene({
        triggerElement: '.content--our-approach .content__wrapper',
        duration: ourApproachGetHeight,
        triggerHook: "onEnter"
    }).setTween(ourApproachTween).addTo(parallaxController);

    ourCapabilitiesTween = new TimelineMax()
        .add([
            //TweenMax.fromTo('.js-our-capabilities', 1, {yPercent: 30, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
            TweenMax.fromTo('.js-floating-product-2', 1, {yPercent: 20, xPercent: 0}, {yPercent: -20, xPercent: 0, ease: Power0.easeNone}),
        ]);

    ourCapabilitiesScene = new ScrollMagic.Scene({
        triggerElement: '.overlap--center-about-bottom .overlap__image',
        duration: ourCapabiltiesGetHeight,
        triggerHook: "onEnter"
    }).setTween(ourCapabilitiesTween).addTo(parallaxController);

    windowResizeIndex();
    $(window).on('resize', windowResizeIndex);
});

function windowResizeIndex() {

    if (parallaxController === null) return;

    let enabled = scrollMagicActive();

    aboutUsScene.enabled(enabled);
    ourApproachScene.enabled(enabled);
    ourCapabilitiesScene.enabled(enabled);

    if (enabled) {
        aboutUsScene.update(true);
        ourApproachScene.update(true);
        ourCapabilitiesScene.update(true);
    } else {
        $('.js-about-us').attr('style', '');
        $('.js-our-approach').attr('style', '');
        $('.js-our-capabilities').attr('style', '');
        $('.js-floating-product-1').attr('style', '');
        $('.js-floating-product-2').attr('style', '');
    }
}

function aboutUsGetHeight() {
    return $('.overlap--center-about-top .overlap__image').outerHeight() * 2;
}

function ourApproachGetHeight() {
    return $('.content--our-approach .content__wrapper').outerHeight() * 2.5;
}

function ourCapabiltiesGetHeight() {
    return $('.overlap--center-about-bottom .overlap__image').outerHeight() * 2;
}
